<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form
        layout="inline"
        @submit="handleSearch"
        :autoFormCreate="
          (form) => {
            this.searchForm = form;
          }
        "
      >
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="供应商" fieldDecoratorId="supplier_id">
              <a-select placeholder="请选择" allowClear show-search option-filter-prop="children">
                <a-select-option v-for="item in suppliers" :key="item.id">{{
                  item.name
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="门店" fieldDecoratorId="branch_id">
              <a-select placeholder="请选择" allowClear show-search option-filter-prop="children">
                <a-select-option v-for="item in branches" :key="item.id">{{
                  item.name
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="操作人" fieldDecoratorId="admin_user_id">
              <a-select placeholder="请选择" allowClear show-search option-filter-prop="children">
                <a-select-option v-for="item in operators" :key="item.id">{{
                  item.real_name
                }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="订单编号" fieldDecoratorId="order_no">
              <a-input placeholder="采购订单编号" />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="订单日期" fieldDecoratorId="date_range">
              <a-range-picker />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="订单状态" fieldDecoratorId="state">
              <a-select placeholder="请选择" allowClear>
                <a-select-option :key="4">到货异常</a-select-option>
                <a-select-option :key="5">处理完毕</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-button type="primary" htmlType="submit">查询</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <s-table ref="table" size="default" :columns="columns" :data="loadData">
      <template slot="order_pic_url" slot-scope="text">
        <a :href="text" target="_blank"><img :src="text" style="width:80px;height:80px;"/></a>
      </template>
      <template slot="type" slot-scope="text">
        {{ text | purchaseTypeStr }}
      </template>
      <template slot="is_payment" slot-scope="text">
        {{ text ? "有账期" : "无账期" }}
      </template>
      <template slot="state" slot-scope="text">
        {{ text | SorderStateFilter }}
      </template>
      <template slot="branch_name" slot-scope="text, record">
        <span v-if="record.type == 0 || record.type == 1">{{ text }}</span>
        <span v-else>{{ text + "," + record.purchase_order_move_record.map(item=>item.branch_name).join(",")}}</span>
      </template>
      <template slot="action" slot-scope="text, record">
        <div class="editable-row-operations">
          <a @click="handleView(record)">查看</a>
          <a-divider v-if="canRemark" type="vertical" />
          <a v-if="canRemark" @click="handleRemark(record)">查看备注</a>
          <template v-if="record.state == 4">
            <a-divider v-if="canRemark" type="vertical" />
            <a v-if="canRemark" @click="handleOverPurchaseAbnormal(record)">完结异常</a>
          </template>
        </div>
      </template>
    </s-table>
    <a-modal
      title="备注"
      :visible="remarkVisible"
      @ok="_handleOk"
      @cancel="handleCancel"
      :maskClosable="false"
    >
      <s-table
        ref="remark"
        :columns="remarkColums"
        :data="loadRemarkData"
        :pageSize="5"
      >
        <template slot="remarkType" slot-scope="text">
          {{ text === 1 ? "门店留言" : "采购留言" }}
        </template>
      </s-table>
      <a-textarea
        :rows="3"
        v-model.number="currentRecord.remark"
        placeholder="请填写处理备注"
      />
      <div class="tips">
        <p>
          请根据与厂商沟通后订单异常原因告知门店处理结果以及后续如何处理该笔订单
        </p>
        <p>异常情况提示以及处理方式：</p>
        <p>情况1：厂商分批发货-处理方式：备注告知门店,等待到货后正常收货</p>
        <p>
          情况2：厂商货品数量有误 -处理方式：点击退款
          备注告知门店让门店点击处理完毕(仅限于实际到货低于采购量，如实际到货数量高于采购量则根据实际到货量生成新订单)
        </p>
        <p>
          情况3: 厂商货品种类有误-处理方式： 点击退款
          生成实际到货商品的新订单，并将新生成订单的订单编号备注,让门店对新订单收货/对旧订单点击处理完毕
        </p>
      </div>
    </a-modal>
  </a-card>
</template>
<script>
import STable from "@/components/table/";
import { getBranchList } from "@/api/branch";
import { getRemarkList } from "@/api/stock";
import { getSupplierList } from "@/api/supplier";
import { getAbnormalList, remarkPurchase ,overPurchaseAbnormal} from "@/api/purchase";
import { getStaffList } from "@/api/staff";

export default {
  name: "Abnormal",
  components: {
    STable,
  },
  data() {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
      },
      form: null,
      // 查询参数
      visible: false,
      loading: false,
      downloadLoading: false,
      searchForm: null,
      courier: "",
      advanced: false,
      imgForm: {},
      queryParam: {},
      currentRecord: {},
      // 表头
      temp: {},
      operators: [],
      branches: [],
      suppliers: [],
      canRemark: false,
      remarkVisible: false,
      columns: [
        {
          title:"订单照片",
          dataIndex: "order_pic_url",
          scopedSlots: { customRender: "order_pic_url" },
        },
        {
          title: "采购订单编号",
          dataIndex: "order_no",
        },
        {
          title: "采购操作人",
          dataIndex: "admin_user_name",
        },
        {
          title: "门店",
          dataIndex: "branch_name",
          scopedSlots:{customRender:"branch_name"}
        },
        {
          title: "订单类型",
          dataIndex: "type",
          scopedSlots: { customRender: "type" },
        },
        {
          title: "下单时间",
          dataIndex: "created",
        },
        {
          title: "订单状态",
          dataIndex: "state",
          scopedSlots: { customRender: "state" },
        },
        // {
        //   title: "异常原因",
        //   dataIndex: "cause",
        // },
        // {
        //   title: "备注",
        //   dataIndex: "remark",
        // },
        {
          title: "操作",
          dataIndex: "action",
          scopedSlots: { customRender: "action" },
        },
      ],
      remarkColums: [
        {
          title: "备注类型",
          dataIndex: "type",
          scopedSlots: { customRender: "remarkType" },
        },
        {
          title: "备注内容",
          dataIndex: "content",
        },
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: (params) => {
        return getAbnormalList(Object.assign(params, this.queryParam)).then(
          (res) => res
        );
      },
      loadRemarkData: (params) => {
        if (this.currentRecord && this.currentRecord.id) {
          const page = params.page || 1;
          const page_size = params.page_size || 5;
          return getRemarkList({ page, page_size }, this.currentRecord.id).then(
            (res) => res
          );
        }
        return Promise.resolve([]);
      },
    };
  },
  created() {
    this.getBranchList();
    this.getSupplierList();
    this.getOperators();
    let userInfo = this.$ls.get("userInfo") || {};
    console.log(userInfo);
    if (userInfo.role === "admin" || userInfo.role === "merchandiser") {
      this.canRemark = true;
    }
  },
  methods: {
    getBranchList: function () {
      getBranchList().then((res) => {
        this.branches = res.list;
      });
    },
    getSupplierList: function () {
      getSupplierList().then((res) => {
        this.suppliers = res.list;
      });
    },
    getOperators: function () {
      getStaffList().then((res) => {
        this.operators = res.list;
      });
    },
    handleSearch(e) {
      e.preventDefault();
      let filter = {
        supplier_id: this.searchForm.getFieldValue("supplier_id"),
        branch_id: this.searchForm.getFieldValue("branch_id"),
        admin_user_id: this.searchForm.getFieldValue("admin_user_id"),
        state: this.searchForm.getFieldValue("state"),
        order_no: this.searchForm.getFieldValue("order_no"),
      };
      const date_range = this.searchForm.getFieldValue("date_range");
      if (date_range) {
        filter["start_date"] = date_range[0].format("YYYY-MM-DD");
        filter["end_date"] = date_range[1].format("YYYY-MM-DD");
      }
      this.queryParam = { ...filter };
      this.$refs.table.refresh();
    },
    handleReset() {
      this.searchForm.resetFields();
      this.queryParam = {};
      this.$refs.table.refresh();
    },

    handleView(row) {
      let routertwo = this.$router.resolve({
        name: "Abnormaltail",
        params: { id: row.id },
      });
      window.open(routertwo.href, "_blank");
    },
    handleRemark(row) {
      this.currentRecord = { ...row };
      this.remarkVisible = true;
    },
    handleCancel() {
      this.currentRecord = {};
      this.remarkVisible = false;
    },
    _handleOk() {
      if (!this.currentRecord.remark) {
        this.$message.error("请填写备注");
        return;
      }
      const params = {
        id: this.currentRecord.id,
        remark: this.currentRecord.remark,
      };
      remarkPurchase(params).then((res) => {
        this.$message.success("操作成功");
        this.$refs.table.refresh();
        this.handleCancel();
      });
    },
    handleOverPurchaseAbnormal(row){
      overPurchaseAbnormal(row.id).then((res) => {
        this.$message.success("操作成功");
        this.$refs.table.refresh();
      });
    }
  },
};
</script>
<style scoped>
.tips {
  font-weight: bold;
  margin-top: 20px;
}
</style>
